export const isGuestConfigItem = (itemId: string) => {
  return itemId.startsWith("G-");
};
